var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 35,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon | Notification new"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0044 30.8638C18.0044 32.75 16.4612 34.2932 14.575 34.2932C12.6888 34.2932 11.1456 32.75 11.1456 30.8638H18.0044ZM25.7206 18.722V24.005L29.15 27.4344V29.1491H0V27.4344L3.42941 24.005V14.5741C3.42941 9.30999 7.08173 4.9032 12.0029 3.7372V2.57206C12.0029 1.14799 13.1518 0 14.575 0C15.9982 0 17.147 1.14799 17.147 2.57206V3.7372C18.434 4.04211 19.6341 4.56864 20.7048 5.27416C19.7918 5.98298 19.0465 6.8976 18.5386 7.94841C17.381 7.25573 16.0255 6.85796 14.575 6.85796C10.3054 6.85796 6.85882 10.3045 6.85882 14.5741V25.7197H22.2912V18.102C23.2153 18.5078 24.2367 18.733 25.3107 18.733C25.4482 18.733 25.5849 18.7293 25.7206 18.722Z",
    fill: "#1F2428"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 11,
    r: 6,
    fill: "#DA291C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationNew);
export default __webpack_public_path__ + "static/media/NotificationNew.f18bba1278637004a46e6bffd3cbb12a.svg";
export { ForwardRef as ReactComponent };